import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            flexDirection: 'column',
            width: '100%',
            gap: remCalc(16),
        },
        errorText: {
            textStyle: 'body-xxsmall',
            color: 'text.danger',
        },
        unavailable: {
            textStyle: 'body-xxsmall',
            color: 'text.tertiary',
        },
        backToLookupBtn: {
            variant: 'text-button',
            textStyle: 'body-xsmall',
            fontWeight: 400,
            justifyContent: 'flex-start',
            marginTop: remCalc(-8),
        },
        gaps: {
            gap: remCalc(20),
            flexDirection: {base: 'column', md: 'row'},
            paddingY: {
                base: remCalc(4),
                lg: remCalc(8),
            },
        },
        divider: {
            // borderBottom: 'small',
            // borderStyle: 'solid',
            // borderColor: 'border.light',
            // paddingBottom: remCalc(16),
        },
        deliveryNoteText: {
            textStyle: 'body-xxsmall',
            color: 'text.secondary',
        },
    },
    variants: {
        contactUs: {
            container: {
                gap: remCalc(32),
            },
            gaps: {
                gap: [remCalc(32), remCalc(32), remCalc(32), remCalc(20)],
                paddingY: {
                    base: 0,
                    lg: 0,
                },
            },
        },
        accountForm: {
            container: {
                gap: {
                    base: remCalc(18),
                    lg: remCalc(22),
                },
            },
        },
    },
}
